import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NewreminderPage } from './newreminder';

@NgModule({
  declarations: [
    NewreminderPage,
  ],
  imports: [
    IonicPageModule.forChild(NewreminderPage),
  ],
})
export class NewreminderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/newreminder/newreminder.module.ts